export const getFileExtension = (filename: string) => {
  return filename.split('.').slice(-1)
}

type FileReaderResult = string // | ArrayBuffer | null | undefined

const readAsDataURL = (file: File | Blob): Promise<FileReaderResult> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()

    // set onload handler
    fileReader.onload = (ev: ProgressEvent<FileReader>) => {
      if (!ev || !ev.target || !ev.target.result) reject('invalid result')
      resolve(ev?.target?.result as string)
    }

    // set onerror handler
    fileReader.onerror = (ev: ProgressEvent<FileReader>) => {
      reject(ev)
    }

    // start reading file
    fileReader.readAsDataURL(file)
  })
}

const loadImage = (src: FileReaderResult): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    // Initiate the JavaScript Image object.
    const img = new Image()

    // Validate the File Height and Width.
    img.onload = () => resolve(img)

    img.onerror = reject

    // Set the Base64 string return from FileReader as source.
    img.src = src
  })
}

export const readImageFile = (file: File | Blob): Promise<HTMLImageElement> => {
  return readAsDataURL(file).then((src: string) => loadImage(src))
}
